<template>
  <div class="jd" v-if="job">
    <div class="jd-container">
      <div class="jd-desc-header d-flex pt-2 me-4 ms-4">
        <p class="jd-detail font-weight-bold font-18">
          求人詳細
          <span class="jd-date ms-2">求人反映/更新日： {{ jobDate }}</span>
        </p>
      </div>
      <div class="job-description">
        <div class="job-title mb-3 d-flex">
          <h2 v-html="highlightedJobTitle"></h2>
        </div>
        <!-- <p @click="openJdLink()" class="jd-link">
          採用ホームページリンク
        </p> -->
        <div v-html="highlightedJobDescription" class="message-body" v-linkified></div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  name: 'ModalJobDescription',
  props: {
    job: {
      type: Object,
      required: true,
    },
    highlightedJobTitle: {
      type: String,
      required: true
    },
  },
  computed: {
    jobDate() {
      const { created_date } = this.job;
      return moment(created_date).format('YYYY-MM-DD');
    },
    highlightedJobDescription() {
      return this.processJobDescription();
    }
  },
  methods: {
    openJdLink() {
      window.open(this.job.jd_url, '_blank');
    },
    escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },
    processJobDescription() {
      if (!this.job.highlights || !this.job.highlights.length) {
        return this.job.job_description;
      }

      const highlight = this.job.highlights.find((h) => h.path === 'job_description');
      if (!highlight || !highlight.texts) {
        return this.job.job_description;
      }

      // Get all hit values and sort them by length
      const hitTexts = highlight.texts
        .filter(text => text.type === 'hit')
        .sort((a, b) => b.value.length - a.value.length);

      // Check if any hit contains HTML or if the job description contains HTML
      if (hitTexts.some(text => text.value.includes('<')) || this.job.job_description.includes('<')) {
        // Handle HTML content
        let fullContent = this.job.job_description;
        
        hitTexts.forEach(text => {
          const escapedValue = this.escapeRegExp(text.value);
          // Create regex that doesn't match inside HTML tags
          const regex = new RegExp(`(${escapedValue})(?![^<]*>)`, 'g');
          fullContent = fullContent.replace(regex, `<span class="highlight-hit">$1</span>`);
        });
        
        return fullContent;
      } else {
        // Handle plain text while preserving non-hit texts
        let result = '';
        highlight.texts.forEach(text => {
          if (text.type === 'hit') {
            // Find the corresponding sorted hit text
            const sortedHit = hitTexts.find(hit => hit.value === text.value);
            result += `<span class="highlight-hit">${sortedHit.value}</span>`;
          } else {
            result += text.value;
          }
        });
        
        return result;
      }
    },
  },
};
</script>

<style scoped>
.highlight-hit {
  background-color: yellow;
}

.jd {
  background-color: #EBEFF1;
}

.jd-date {
  font-size: 11px; 
  font-weight: 600;
}

.jd-link {
  cursor: pointer;
  text-decoration: none;
  color: blue;
}

.font-18 {
  font-size: 18px;
}

.jd-desc-header {
  justify-content: space-between;
}

.job-description {
  max-height: 87vh !important;
  overflow-y: scroll !important;
  padding: 10px;
}

.job-title {
  padding: 10px 5px 5px 5px;
  background-color: #fff;
  border-radius: 10px;
  font-weight: 600;
  font-size: 18px;
}

h2 {
  cursor: pointer;
  font-size: 18px;
}

.jd-header {
  padding: 2px;
  /* margin-top: 5px; */
}

.jd-header p {
  font-size: 18px;
  color: #3c3c3c;
  font-weight: normal;
  margin: auto;
  padding: 10px;
  cursor: pointer;
}

.job-description {
  padding: 20px;
  /* margin-bottom: 20px; */
  color: #000;
}

.job-description p {
  font-size: 18px;
}
</style>